module.exports = __webpack_public_path__ + "static/media/rebom.7ece0d02.jpg";